/**
 *  All apis which are defined in backend tanzhi app
 */

export const SALES_API_BASE_URL = '/api/sales';

export const TANZHI_API_BASE_URL = '/api/tanzhi';

export const AUTH_API_BASE_URL = '/api/auth';

export const USERS_API_BASE_URL = '/api/users';

export const LOG_API_BASE_URL = '/api/log';
